import { Link } from "react-router-dom";
import { Map, MapPin, Tag, Hotel, Users, Wrench, ChevronRight } from "lucide-react";

/* Six feature cards inspired by the "Explore the World, Together" home
   mockup — a warmer entry point above the pastel icon grid for visitors who
   prefer descriptions over icon-only shortcuts. */

const CARDS = [
  { to: "/plan-ai",          Icon: Map,    tint: "bg-emerald-50  text-emerald-700",  title: "Plan a Trip",       body: "Build itineraries, save places, and keep everything organized." },
  { to: "/explore-places",   Icon: MapPin, tint: "bg-sky-50      text-sky-700",      title: "Explore Places",    body: "Discover destinations with real traveller insights." },
  { to: "/loyalty",          Icon: Tag,    tint: "bg-rose-50     text-rose-700",     title: "Find Deals",        body: "Compare prices and find the best travel offers." },
  { to: "/stays",            Icon: Hotel,  tint: "bg-fuchsia-50  text-fuchsia-700",  title: "Stay & Hotels",     body: "Find the perfect place to stay for every trip." },
  { to: "/community",        Icon: Users,  tint: "bg-amber-50    text-amber-700",    title: "Travel Community",  body: "Connect, share experiences and get advice." },
  { to: "/features",         Icon: Wrench, tint: "bg-violet-50   text-violet-700",   title: "Travel Tools",      body: "Packing lists, expense trackers, maps and more." },
];

export default function HomeFeatureCards() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="home-feature-cards">
      {CARDS.map(({ to, Icon, tint, title, body }) => (
        <Link key={title} to={to} data-testid={`home-feature-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
          className="group relative flex items-start gap-3 p-4 rounded-2xl border border-border bg-card hover:border-accent hover:shadow-warm-md transition-[border-color,box-shadow] tap min-h-[110px]">
          <div className={`shrink-0 w-11 h-11 rounded-xl inline-flex items-center justify-center ${tint}`}>
            <Icon className="w-5 h-5" strokeWidth={1.75} />
          </div>
          <div className="min-w-0 flex-1 pr-6">
            <div className="font-serif font-700 text-base text-primary leading-tight">{title}</div>
            <div className="text-xs text-muted-foreground mt-1 leading-snug">{body}</div>
          </div>
          <ChevronRight className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-primary/60 group-hover:text-accent transition-colors" />
        </Link>
      ))}
    </section>
  );
}
